class PathItem extends require("lib/static-shim").default(
  require("lib/utils/model").default
) {
  static initClass() {
    this.prototype.defaults = { description: "" }
  }

  url() {
    let url = this.urlRoot(`/api/private/path/${this.get("path_id")}/item/`)
    const { sync_source_id } = this.attributes
    if (sync_source_id != null) {
      url = `${url}${sync_source_id}/`
    }
    return url
  }

  initialize() {
    const PathItems = require("path/models/items").default
    this.items = new PathItems(this.get("items"))
    return (this.items.comparator = "order")
  }

  sourceID() {
    return this.get("sync_source_id")
  }

  isCompleted() {
    return __guard__(this.get("completion"), (x) => x.progress) === 1.0
  }

  toJSON() {
    const data = super.toJSON()
    if (data.item_type === "G") {
      data.items = this.items.toJSON()
    } else {
      delete data["items"]
    }
    return data
  }
}
PathItem.initClass()
export default PathItem

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
